export let allFoldersInSharedMailbox = "edYyNd";
export let allFoldersInPstFile = "ikFWD";
export let allPstFiles = "bjLa7d";
export default {allFoldersInSharedMailbox,allFoldersInPstFile,allPstFiles};